import React, { Component } from 'react';
import KickImage from 'Reuseables/KickImage';
import lineIcon from '../../images/line-icon.png';
import IconClose from '../../images/tutup-button.png';
import {
  Col,
  Alert,
  Button,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Container
} from 'reactstrap';

const DEFAULT_ERR_MSG = 'Houston, we have a problem !. Please inform our friendly staff via Whatsapp Error code ';

export default class ModalErrorInfo extends Component{
  render() {
    return(
      <Modal  style={{  
        marginTop: 150
        }} 
        isOpen={this.props.isOpen} 
        toggle={this.props.onToggle} 
        className="kick-modal"
      >
        <ModalBody>
            <Container className="text-center">
              <Alert color="danger">{ DEFAULT_ERR_MSG + this.props.statusCode }</Alert>
           </Container>
        </ModalBody>
         <ModalFooter>
           <Container className="text-center">
              <Button className="btn-green bold" block size="lg" onClick={this.props.onToggle}>OK</Button>{' '}
          </Container>
        </ModalFooter>
      </Modal>
    )
  }
}
